import React from 'react';
import FeatherIcon from 'feather-icons-react';

const LoginActivityModal = ({ user, onClose }) => {
  const metadata = user?.lastLoginMetadata || {};

  const formatDate = (value) => {
    if (!value) {
      return 'Not recorded';
    }

    const dateValue = value.$date || value;
    const parsedDate = new Date(dateValue);

    if (Number.isNaN(parsedDate.getTime())) {
      return String(value);
    }

    return parsedDate.toLocaleString();
  };

  const displayValue = (value) => {
    if (value === null || value === undefined || value === '') {
      return 'Not recorded';
    }

    return String(value);
  };

  const rows = [
    ['Last Login At', metadata.loginAt || user?.lastSuccessfulLoginDate],
    ['Platform', metadata.platform],
    ['Operating System', metadata.operatingSystem],
    ['OS Version', metadata.osVersion],
    ['App Version', metadata.appVersion],
    ['Device Brand', metadata.deviceBrand],
    ['Device Model', metadata.deviceModel],
    ['IP Address', metadata.ipAddress],
    ['User Agent', metadata.userAgent],
  ];

  return (
    <div className="sa-popup-bg">
      <div className="sa-popup">
        <div className="sa-modal-box-style">
          <div className="sa-popup-header">
            <span className="sa-model-heading">Login Activity</span>
            <div className="sa-popup-close-icon" onClick={onClose}>
              <FeatherIcon className="sa-modal-close-icon" icon="x" />
            </div>
          </div>
          <div className="sa-popup-content">
            <div className="row">
              <div className="col-md-6">
                <div className="form-group m-b-16">
                  <label>User</label>
                  <input
                    type="text"
                    className="form-control view-text-muted"
                    value={displayValue(user?.lastName || user?.username)}
                    disabled
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group m-b-16">
                  <label>Email</label>
                  <input
                    type="text"
                    className="form-control view-text-muted"
                    value={displayValue(user?.email)}
                    disabled
                  />
                </div>
              </div>

              {rows.map(([label, value]) => (
                <div className="col-md-6" key={label}>
                  <div className="form-group m-b-16">
                    <label>{label}</label>
                    <input
                      type="text"
                      className="form-control view-text-muted"
                      value={label === 'Last Login At' ? formatDate(value) : displayValue(value)}
                      disabled
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginActivityModal;
